(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@shraddhar/web/floating-label'), require('@shraddhar/web/line-ripple'), require('@shraddhar/web/notched-outline'), require('@shraddhar/web/form-field'), require('@shraddhar/web/menu'), require('@shraddhar/web/list'), require('@angular/forms'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@shraddhar/web/ripple'), require('@material/select'), require('@material/ripple')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/select', ['exports', '@angular/core', '@angular/common', '@shraddhar/web/floating-label', '@shraddhar/web/line-ripple', '@shraddhar/web/notched-outline', '@shraddhar/web/form-field', '@shraddhar/web/menu', '@shraddhar/web/list', '@angular/forms', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@shraddhar/web/base', '@shraddhar/web/ripple', '@material/select', '@material/ripple'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.select = {}), global.ng.core, global.ng.common, global.ng.web.floatingLabel, global.ng.web.lineRipple, global.ng.web.notchedOutline, global.ng.web.formField, global.ng.web.menu, global.ng.web.list, global.ng.forms, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.ng.web.base, global.ng.web.ripple, global.mdc.select, global.mdc.ripple));
}(this, (function (exports, core, common, floatingLabel, lineRipple, notchedOutline, formField, menu, list, forms, coercion, platform, rxjs, operators, base, ripple, select, ripple$1) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MdcSelectIcon = /** @class */ (function () {
        function MdcSelectIcon() {
        }
        MdcSelectIcon.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcSelectIcon]',
                        exportAs: 'mdcSelectIcon',
                        host: { 'class': 'mdc-select__icon' }
                    },] }
        ];
        return MdcSelectIcon;
    }());

    var MdcSelectHelperTextFoundation = /** @class */ (function (_super) {
        __extends(MdcSelectHelperTextFoundation, _super);
        function MdcSelectHelperTextFoundation(_hostElement, _document) {
            var _this = _super.call(this, _hostElement) || this;
            _this._hostElement = _hostElement;
            _this._document = _document;
            _this._initialized = false;
            return _this;
        }
        Object.defineProperty(MdcSelectHelperTextFoundation.prototype, "foundation", {
            get: function () {
                return this._foundation;
            },
            enumerable: true,
            configurable: true
        });
        MdcSelectHelperTextFoundation.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._helperLineElement.classList.add(className); },
                removeClass: function (className) { return _this._helperLineElement.classList.remove(className); },
                hasClass: function (className) { return _this._helperLineElement.classList.contains(className); },
                setAttr: function (attr, value) { return _this._helperLineElement.setAttribute(attr, value); },
                removeAttr: function (attr) { return _this._helperLineElement.removeAttribute(attr); },
                setContent: function (content) { return _this._helperLineElement.textContent = content; },
            };
            return new select.MDCSelectHelperTextFoundation(adapter);
        };
        /** Sets the persistency of the helper text. */
        MdcSelectHelperTextFoundation.prototype.setPersistent = function (isPersistent) {
            this._foundation.setPersistent(isPersistent);
        };
        /** True to make the helper text act as an error validation message. */
        MdcSelectHelperTextFoundation.prototype.setValidation = function (isValidation) {
            this._foundation.setValidation(isValidation);
        };
        /** Sets the validity of the helper text based on inputIsValid. */
        MdcSelectHelperTextFoundation.prototype.setValidity = function (inputIsValid) {
            this._foundation.setValidity(inputIsValid);
        };
        /** Makes the helper text visible to the screen reader. */
        MdcSelectHelperTextFoundation.prototype.showToScreenReader = function () {
            this._foundation.showToScreenReader();
        };
        /** Sets the content of the helper text. */
        MdcSelectHelperTextFoundation.prototype.setContent = function (content) {
            this._foundation.setContent(content);
        };
        /** Initializes the foundation. */
        MdcSelectHelperTextFoundation.prototype.init = function () {
            if (this._initialized) {
                return;
            }
            this._createHelperElement();
            this._foundation.init();
            this._initialized = true;
        };
        /** Destroys the foundation. */
        MdcSelectHelperTextFoundation.prototype.destroy = function () {
            var _a, _b;
            (_b = (_a = this._helperLineElement) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(this._helperLineElement);
            this._hostElement = this._helperLineElement = null;
            this._foundation.destroy();
            this._initialized = false;
        };
        /** Creates and appends the helper element. */
        MdcSelectHelperTextFoundation.prototype._createHelperElement = function () {
            this._helperLineElement = this._document.createElement('p');
            this._helperLineElement.className = 'mdc-select-helper-text';
            this._appendHelperElement();
        };
        /**
         * Appends the helper element to the select.
         */
        MdcSelectHelperTextFoundation.prototype._appendHelperElement = function () {
            if (!this._helperLineElement) {
                throw Error('Helper element has not been created and cannot be appended');
            }
            this._hostElement.nativeElement.insertAdjacentElement('afterend', this._helperLineElement);
        };
        MdcSelectHelperTextFoundation.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        return MdcSelectHelperTextFoundation;
    }(base.MDCComponent));

    /**
     * Injection token that can be used to configure the default options for all
     * mdc-select usage within an app.
     */
    var MDC_SELECT_DEFAULT_OPTIONS = new core.InjectionToken('MDC_SELECT_DEFAULT_OPTIONS');
    var MdcSelectBase = /** @class */ (function (_super) {
        __extends(MdcSelectBase, _super);
        function MdcSelectBase(_elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
            var _this = _super.call(this, _elementRef) || this;
            _this._elementRef = _elementRef;
            _this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            _this._parentForm = _parentForm;
            _this._parentFormGroup = _parentFormGroup;
            _this.ngControl = ngControl;
            return _this;
        }
        return MdcSelectBase;
    }(base.MDCComponent));
    var _MdcSelectMixinBase = formField.mixinErrorState(MdcSelectBase);
    var MdcSelectChange = /** @class */ (function () {
        function MdcSelectChange(source, index, value) {
            this.source = source;
            this.index = index;
            this.value = value;
        }
        return MdcSelectChange;
    }());
    var nextUniqueId = 0;
    var MdcSelect = /** @class */ (function (_super) {
        __extends(MdcSelect, _super);
        function MdcSelect(_platform, _changeDetectorRef, elementRef, _defaultErrorStateMatcher, _document, _parentFormField, _ripple, ngControl, _parentForm, _parentFormGroup, _defaults) {
            var _this = _super.call(this, elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            _this._document = _document;
            _this._parentFormField = _parentFormField;
            _this._ripple = _ripple;
            _this.ngControl = ngControl;
            _this._defaults = _defaults;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._uniqueId = "mdc-select-" + ++nextUniqueId;
            _this._initialized = false;
            _this._selectedText = '';
            _this.id = _this._uniqueId;
            _this._disabled = false;
            _this._outlined = false;
            _this._required = false;
            _this.compareWith = function (a1, a2) { return a1 === a2; };
            _this._helperPersistent = false;
            /** Event emitted when the selected value has been changed by the user. */
            _this.selectionChange = new core.EventEmitter();
            /**
             * Event that emits whenever the raw value of the select changes. This is here primarily
             * to facilitate the two-way binding for the `value` input.
             */
            _this.valueChange = new core.EventEmitter();
            _this.blur = new core.EventEmitter();
            _this._onFocus = new core.EventEmitter();
            /** View to model callback called when value changes */
            _this._onChange = function () { };
            /** View to model callback called when select has been touched */
            _this._onTouched = function () { };
            _this._root = _this.elementRef.nativeElement;
            if (_this.ngControl) {
                // Note: we provide the value accessor through here, instead of
                // the `providers` to avoid running into a circular import.
                _this.ngControl.valueAccessor = _this;
            }
            if (_this._parentFormField) {
                _parentFormField.elementRef.nativeElement.classList.add('ngx-form-field-select');
            }
            // Force setter to be called in case id was not specified.
            _this.id = _this.id;
            _this._setDefaultGlobalOptions();
            return _this;
        }
        Object.defineProperty(MdcSelect.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabledState(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "outlined", {
            get: function () {
                return this._outlined;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                this._outlined = newValue;
                this.layout();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "required", {
            get: function () {
                return this._required;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._required) {
                    this._required = newValue;
                    if (this._initialized && !this._required) {
                        this.valid = true;
                        this._syncHelperValidityState();
                        this._changeDetectorRef.markForCheck();
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "valid", {
            get: function () {
                return this._valid;
            },
            set: function (value) {
                var _a;
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._valid) {
                    this._valid = newValue;
                    (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.setValid(newValue);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "value", {
            /** Value of the select */
            get: function () {
                return this._value;
            },
            set: function (newValue) {
                if (newValue !== this._value) {
                    this.setSelectionByValue(newValue);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "helperPersistent", {
            get: function () {
                return this._helperPersistent;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._helperPersistent) {
                    this._helperPersistent = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "_hasPlaceholder", {
            get: function () {
                return this.placeholder ? this.placeholder.length > 0 : false;
            },
            enumerable: true,
            configurable: true
        });
        MdcSelect.prototype.getDefaultFoundation = function () {
            // Do not initialize foundation until ngAfterViewInit runs
            if (!this._initialized) {
                return undefined;
            }
            var adapter = __assign(__assign(__assign(__assign({}, this._getSelectAdapterMethods()), this._getCommonAdapterMethods()), this._getOutlineAdapterMethods()), this._getLabelAdapterMethods());
            return new select.MDCSelectFoundation(adapter, this._getFoundationMap());
        };
        MdcSelect.prototype._getSelectAdapterMethods = function () {
            var _this = this;
            return {
                getSelectedMenuItem: function () {
                    return _this._menu.elementRef.nativeElement.querySelector(select.strings.SELECTED_ITEM_SELECTOR);
                },
                getMenuItemAttr: function (menuItem, attr) { return menuItem.getAttribute(attr); },
                setSelectedText: function (text) { return _this._selectedText = text; },
                isSelectAnchorFocused: function () { return _this._platform.isBrowser ?
                    document.activeElement === _this._selectAnchor.nativeElement : false; },
                getSelectAnchorAttr: function (attr) { return _this._selectAnchor.nativeElement.getAttribute(attr); },
                setSelectAnchorAttr: function (attr, value) { return _this._selectAnchor.nativeElement.setAttribute(attr, value); },
                openMenu: function () { return _this._menu.open = true; },
                closeMenu: function () { return _this._menu.open = false; },
                getAnchorElement: function () { return _this._selectAnchor.nativeElement; },
                setMenuAnchorElement: function (anchorEl) { return _this._menu.anchorElement = anchorEl; },
                setMenuAnchorCorner: function (anchorCorner) { return _this._menu.anchorCorner = anchorCorner; },
                setMenuWrapFocus: function (wrapFocus) { return _this._menu.wrapFocus = wrapFocus; },
                setAttributeAtIndex: function (index, attributeName, attributeValue) {
                    return _this._menu._list.items.toArray()[index].getListItemElement().setAttribute(attributeName, attributeValue);
                },
                removeAttributeAtIndex: function (index, attributeName) {
                    return _this._menu._list.items.toArray()[index].getListItemElement().removeAttribute(attributeName);
                },
                focusMenuItemAtIndex: function (index) { return _this._menu._list.items.toArray()[index].focus(); },
                getMenuItemCount: function () { return _this._menu._list.items.length; },
                getMenuItemValues: function () { var _a; return (_a = _this._menu._list.items.map(function (el) {
                    return el.getListItemElement().getAttribute(select.strings.VALUE_ATTR) || '';
                })) !== null && _a !== void 0 ? _a : []; },
                getMenuItemTextAtIndex: function (index) { var _a; return (_a = _this._menu._list.items.toArray()[index].getListItemElement().textContent) !== null && _a !== void 0 ? _a : ''; },
                addClassAtIndex: function (index, className) {
                    return _this._menu._list.items.toArray()[index].getListItemElement().classList.add(className);
                },
                removeClassAtIndex: function (index, className) {
                    return _this._menu._list.items.toArray()[index].getListItemElement().classList.remove(className);
                }
            };
        };
        MdcSelect.prototype._getCommonAdapterMethods = function () {
            var _this = this;
            return {
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                hasClass: function (className) { return _this._root.classList.contains(className); },
                setRippleCenter: function (normalizedX) { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.setRippleCenter(normalizedX); },
                activateBottomLine: function () { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.activate(); },
                deactivateBottomLine: function () { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.deactivate(); },
                notifyChange: function () { }
            };
        };
        MdcSelect.prototype._getOutlineAdapterMethods = function () {
            var _this = this;
            return {
                hasOutline: function () { return !!_this._notchedOutline; },
                notchOutline: function (labelWidth) { var _a; return (_a = _this._notchedOutline) === null || _a === void 0 ? void 0 : _a.notch(labelWidth); },
                closeOutline: function () { var _a; return (_a = _this._notchedOutline) === null || _a === void 0 ? void 0 : _a.closeNotch(); }
            };
        };
        MdcSelect.prototype._getLabelAdapterMethods = function () {
            var _this = this;
            return {
                hasLabel: function () { return _this._hasPlaceholder; },
                floatLabel: function (shouldFloat) { var _a; return (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.float(shouldFloat); },
                getLabelWidth: function () { var _a, _b; return (_b = (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.getWidth()) !== null && _b !== void 0 ? _b : 0; }
            };
        };
        /** Returns a map of all subcomponents to subfoundations.*/
        MdcSelect.prototype._getFoundationMap = function () {
            var _a;
            return {
                helperText: (_a = this._foundationHelper) === null || _a === void 0 ? void 0 : _a.foundation
            };
        };
        MdcSelect.prototype.ngOnChanges = function (changes) {
            if (changes['helper'] || changes['helperPersistent'] || changes['validationMessage']) {
                this._syncHelper();
            }
        };
        MdcSelect.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._initialized = true;
            this._asyncBuildFoundation()
                .then(function () {
                _this._selectBuilder();
            });
            this._initializeSelection();
            this._subscribeToMenuEvents();
        };
        MdcSelect.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        /** Override MdcSelectBase destroy method */
        MdcSelect.prototype.destroy = function () {
            var _a;
            this._destroyed.next();
            this._destroyed.complete();
            (_a = this._lineRipple) === null || _a === void 0 ? void 0 : _a.destroy();
            this._ripple.destroy();
            this._foundation.destroy();
        };
        MdcSelect.prototype.ngDoCheck = function () {
            if (this.ngControl) {
                // We need to re-evaluate this on every change detection cycle, because there are some
                // error triggers that we can't subscribe to (e.g. parent form submissions). This means
                // that whatever logic is in here has to be super lean or we risk destroying the performance.
                this.updateErrorState();
            }
        };
        MdcSelect.prototype.writeValue = function (value) {
            if (this._initialized) {
                this.setSelectionByValue(value, false);
            }
        };
        MdcSelect.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        MdcSelect.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        MdcSelect.prototype.onFocus = function () {
            if (!this.disabled) {
                this._foundation.handleFocus();
                this._onFocus.emit(true);
            }
        };
        MdcSelect.prototype.onBlur = function () {
            this._foundation.handleBlur();
        };
        MdcSelect.prototype.onClick = function (evt) {
            this._foundation.handleClick(this._getNormalizedXCoordinate(evt));
        };
        MdcSelect.prototype.onKeydown = function (evt) {
            this._foundation.handleKeydown(evt);
        };
        MdcSelect.prototype.getSelectedIndex = function () {
            var _a, _b;
            return (_b = (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.getSelectedIndex()) !== null && _b !== void 0 ? _b : -1;
        };
        MdcSelect.prototype.focus = function () {
            this._selectAnchor.nativeElement.focus();
        };
        MdcSelect.prototype.setSelectedIndex = function (index) {
            var _a, _b;
            this.setSelectionByValue((_b = (_a = this._menu._list) === null || _a === void 0 ? void 0 : _a.getListItemByIndex(index)) === null || _b === void 0 ? void 0 : _b.value, true, index);
        };
        MdcSelect.prototype.setSelectionByValue = function (value, isUserInput, index) {
            if (isUserInput === void 0) { isUserInput = true; }
            var _a;
            if (!this._value && !value) {
                return;
            }
            if (!index) {
                index = (_a = this._menu._list) === null || _a === void 0 ? void 0 : _a.getListItemIndexByValue(value);
            }
            this._value = value;
            this._foundation.setSelectedIndex(index !== null && index !== void 0 ? index : -1, this._menu.closeSurfaceOnSelection);
            if (isUserInput) {
                this._onChange(this._value);
                this.selectionChange.emit(new MdcSelectChange(this, this.getSelectedIndex(), value));
            }
            this.valueChange.emit({
                index: this.getSelectedIndex(),
                value: this._value
            });
            this._syncHelperValidityState();
            this._foundation.handleChange();
            this._changeDetectorRef.markForCheck();
        };
        // Implemented as part of ControlValueAccessor.
        MdcSelect.prototype.setDisabledState = function (disabled) {
            var _a;
            this._disabled = coercion.coerceBooleanProperty(disabled);
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.setDisabled(this._disabled);
            this._changeDetectorRef.markForCheck();
        };
        Object.defineProperty(MdcSelect.prototype, "_hasValue", {
            get: function () {
                var _a;
                return ((_a = this._value) === null || _a === void 0 ? void 0 : _a.length) > 0;
            },
            enumerable: true,
            configurable: true
        });
        /** Initialize Select internal state based on the environment state */
        MdcSelect.prototype.layout = function () {
            var _this = this;
            if (this._initialized) {
                this._asyncBuildFoundation().then(function () {
                    _this._selectBuilder();
                    _this._foundation.layout();
                });
            }
        };
        MdcSelect.prototype._initializeSelection = function () {
            var _this = this;
            // Defer setting the value in order to avoid the "Expression
            // has changed after it was checked" errors from Angular.
            Promise.resolve().then(function () {
                var _a, _b;
                var value = (_b = (_a = _this.ngControl) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : _this._value;
                if (value) {
                    _this.setSelectionByValue(value, false);
                }
            });
        };
        /** Set the default options. */
        MdcSelect.prototype._setDefaultGlobalOptions = function () {
            if (this._defaults) {
                if (this._defaults.outlined != null) {
                    this.outlined = this._defaults.outlined;
                }
            }
        };
        MdcSelect.prototype._asyncBuildFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation = this.getDefaultFoundation();
                    return [2 /*return*/];
                });
            });
        };
        MdcSelect.prototype._asyncInitFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation.init();
                    return [2 /*return*/];
                });
            });
        };
        MdcSelect.prototype._selectBuilder = function () {
            var _this = this;
            this._changeDetectorRef.detectChanges();
            // initialize after running a detectChanges()
            this._asyncInitFoundation()
                .then(function () {
                if (!_this.outlined) {
                    _this._ripple = _this._createRipple();
                    _this._ripple.init();
                }
                _this._menu.wrapFocus = false;
                _this._menu.elementRef.nativeElement.setAttribute('role', 'listbox');
                _this._menu.elementRef.nativeElement.classList.add('mdc-select__menu');
                if (_this._menu._list) {
                    _this._menu._list.useSelectedClass = true;
                    _this._menu._list.singleSelection = true;
                }
            });
        };
        MdcSelect.prototype._subscribeToMenuEvents = function () {
            var _this = this;
            // When the list items change, re-subscribe
            this._menu._list.items.changes.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._initializeSelection(); });
            // Subscribe to menu opened event
            this._menu.opened.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._foundation.handleMenuOpened(); });
            // Subscribe to menu closed event
            this._menu.closed.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () {
                _this._foundation.handleMenuClosed();
                _this._blur();
            });
            // Subscribe to list-item action event
            this._menu.selected.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function (evt) { return _this.setSelectedIndex(evt.index); });
        };
        MdcSelect.prototype._blur = function () {
            this._onTouched();
            this.blur.emit(this.value);
            this._onFocus.emit(false);
            this._syncHelperValidityState();
        };
        MdcSelect.prototype._isValid = function () {
            return (!!this.validationMessage && !this._hasValue && this.required) || this.errorState;
        };
        MdcSelect.prototype._getFloatingLabel = function () {
            var _a, _b;
            return (_a = this._floatingLabel) !== null && _a !== void 0 ? _a : (_b = this._notchedOutline) === null || _b === void 0 ? void 0 : _b.floatingLabel;
        };
        MdcSelect.prototype._syncHelper = function () {
            var _a;
            if (this._shouldRenderHelperText()) {
                this._initHelperFoundation();
            }
            this._foundationHelper.setContent((_a = this.helper) !== null && _a !== void 0 ? _a : '');
            this._foundationHelper.setPersistent(this._helperPersistent);
        };
        MdcSelect.prototype._syncHelperValidityState = function () {
            var _a, _b, _c, _d;
            var showValidationMessage = this._isValid();
            if (this._shouldRenderHelperText()) {
                (_a = this._foundationHelper) === null || _a === void 0 ? void 0 : _a.setContent(showValidationMessage ? (_b = this.validationMessage) !== null && _b !== void 0 ? _b : '' : (_c = this.helper) !== null && _c !== void 0 ? _c : '');
                (_d = this._foundationHelper) === null || _d === void 0 ? void 0 : _d.setValidation(showValidationMessage);
            }
        };
        MdcSelect.prototype._initHelperFoundation = function () {
            if (!this._foundationHelper) {
                this._foundationHelper = new MdcSelectHelperTextFoundation(this._elementRef, this._document);
                this._foundationHelper.init();
            }
        };
        MdcSelect.prototype._shouldRenderHelperText = function () {
            return !!this.helper || !!this.validationMessage;
        };
        /**
         * Calculates where the line ripple should start based on the x coordinate within the component.
         */
        MdcSelect.prototype._getNormalizedXCoordinate = function (evt) {
            var targetClientRect = evt.target.getBoundingClientRect();
            if (evt instanceof MouseEvent) {
                return evt.clientX - targetClientRect.left;
            }
            var clientX = evt.touches[0] && evt.touches[0].clientX;
            return clientX - targetClientRect.left;
        };
        MdcSelect.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, ripple.MdcRipple.createAdapter({ _root: this._selectAnchor.nativeElement })), { registerInteractionHandler: function (evtType, handler) {
                    return _this._selectAnchor.nativeElement.addEventListener(evtType, handler);
                }, deregisterInteractionHandler: function (evtType, handler) {
                    return _this._selectAnchor.nativeElement.removeEventListener(evtType, handler);
                } });
            return new ripple.MdcRipple(this._selectAnchor, new ripple$1.MDCRippleFoundation(adapter));
        };
        MdcSelect.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-select',
                        exportAs: 'mdcSelect',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-select',
                            '[class.mdc-select--disabled]': 'disabled',
                            '[class.mdc-select--outlined]': 'outlined',
                            '[class.mdc-select--required]': 'required',
                            '[class.mdc-select--no-label]': '!_hasPlaceholder',
                            '[class.mdc-select--with-leading-icon]': 'leadingIcon',
                            '[class.mdc-select--invalid]': 'errorState'
                        },
                        template: "<div #selectAnchor class=\"mdc-select__anchor\"\r\n  role=\"button\"\r\n  aria-haspopup=\"listbox\"\r\n  [tabindex]=\"disabled ? '-1' : '0'\"\r\n  [attr.aria-required]=\"required\"\r\n  [attr.aria-labelledby]=\"placeholder\"\r\n  (focus)=\"onFocus()\"\r\n  (blur)=\"onBlur()\"\r\n  (keydown)=\"onKeydown($event)\"\r\n  (click)=\"onClick($event)\">\r\n  <span class=\"mdc-select__ripple\" *ngIf=\"!outlined\"></span>\r\n  <ng-content select=\"mdc-icon\"></ng-content>\r\n  <input #selectSelectedText class=\"mdc-select__selected-text\"\r\n    type=\"text\"\r\n    disabled\r\n    readonly\r\n    [value]=\"_selectedText\" />\r\n    <i class=\"mdc-select__dropdown-icon\"></i>\r\n    <label mdcFloatingLabel *ngIf=\"!outlined\" [for]=\"id\">{{placeholder}}</label>\r\n    <mdc-line-ripple *ngIf=\"!outlined\"></mdc-line-ripple>\r\n    <mdc-notched-outline *ngIf=\"outlined\" [label]=\"placeholder\" [for]=\"id\"></mdc-notched-outline>\r\n</div>\r\n<ng-content select=\"mdc-menu\"></ng-content>\r\n",
                        providers: [
                            ripple.MdcRipple,
                            { provide: formField.MdcFormFieldControl, useExisting: MdcSelect }
                        ],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcSelect.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef },
            { type: formField.ErrorStateMatcher },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] }] },
            { type: formField.MdcFormField, decorators: [{ type: core.Optional }] },
            { type: ripple.MdcRipple, decorators: [{ type: core.Optional }] },
            { type: forms.NgControl, decorators: [{ type: core.Self }, { type: core.Optional }] },
            { type: forms.NgForm, decorators: [{ type: core.Optional }] },
            { type: forms.FormGroupDirective, decorators: [{ type: core.Optional }] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MDC_SELECT_DEFAULT_OPTIONS,] }] }
        ]; };
        MdcSelect.propDecorators = {
            id: [{ type: core.Input }],
            name: [{ type: core.Input }],
            helper: [{ type: core.Input }],
            validationMessage: [{ type: core.Input }],
            placeholder: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            outlined: [{ type: core.Input }],
            required: [{ type: core.Input }],
            valid: [{ type: core.Input }],
            compareWith: [{ type: core.Input }],
            value: [{ type: core.Input }],
            helperPersistent: [{ type: core.Input }],
            errorStateMatcher: [{ type: core.Input }],
            selectionChange: [{ type: core.Output }],
            valueChange: [{ type: core.Output }],
            blur: [{ type: core.Output }],
            _onFocus: [{ type: core.Output, args: ['focus',] }],
            _floatingLabel: [{ type: core.ViewChild, args: [floatingLabel.MdcFloatingLabel, { static: false },] }],
            _lineRipple: [{ type: core.ViewChild, args: [lineRipple.MdcLineRipple, { static: false },] }],
            _notchedOutline: [{ type: core.ViewChild, args: [notchedOutline.MdcNotchedOutline, { static: false },] }],
            _selectAnchor: [{ type: core.ViewChild, args: ['selectAnchor', { static: false },] }],
            _selectSelectedText: [{ type: core.ViewChild, args: ['selectSelectedText', { static: true },] }],
            _menu: [{ type: core.ContentChild, args: [menu.MdcMenu, { static: false },] }],
            leadingIcon: [{ type: core.ContentChild, args: [MdcSelectIcon, { static: false },] }]
        };
        return MdcSelect;
    }(_MdcSelectMixinBase));

    var SELECT_DECLARATIONS = [
        MdcSelect,
        MdcSelectIcon,
    ];
    var MdcSelectModule = /** @class */ (function () {
        function MdcSelectModule() {
        }
        MdcSelectModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            menu.MdcMenuModule,
                            list.MdcListModule,
                            formField.MdcFormFieldModule,
                            floatingLabel.MdcFloatingLabelModule,
                            notchedOutline.MdcNotchedOutlineModule,
                            lineRipple.MdcLineRippleModule
                        ],
                        exports: [
                            menu.MdcMenuModule,
                            list.MdcListModule,
                            formField.MdcFormFieldModule,
                            SELECT_DECLARATIONS
                        ],
                        declarations: SELECT_DECLARATIONS
                    },] }
        ];
        return MdcSelectModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_SELECT_DEFAULT_OPTIONS = MDC_SELECT_DEFAULT_OPTIONS;
    exports.MdcSelect = MdcSelect;
    exports.MdcSelectChange = MdcSelectChange;
    exports.MdcSelectIcon = MdcSelectIcon;
    exports.MdcSelectModule = MdcSelectModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-select.umd.js.map
